<template>
  <div id="usermanage-dialog">
    <el-dialog
      :title="!disabled ? '添加新用户' : '修改用户'"
      :visible.sync="dialog"
      width="40%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="姓名" prop="loginName">
          <el-input
            v-model="ruleForm.loginName"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="detail">
          <el-input v-model="ruleForm.detail" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email" v-if="!disabled">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>

        <el-form-item
          label="密码"
          prop="password"
          :rules="[
            {
              required: !disabled,
              message: '请输入密码',
              trigger: 'blur'
            }
          ]"
        >
          <el-input type="password" v-model="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item
          label="密码确认"
          prop="password2"
          :rules="[
            {
              required: !disabled,
              validator: validatePass,
              trigger: 'blur'
            }
          ]"
        >
          <el-input type="password" v-model="ruleForm.password2"></el-input>
        </el-form-item>
        <el-form-item label="身份" prop="value">
          <el-select v-model="ruleForm.value" placeholder>
            <el-option label="管理员" value="ADMIN"></el-option>
            <el-option label="用户" value="USER"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="resetForm('ruleForm')"
          >取 消</el-button
        >
        <el-button
          :loading="loading"
          type="primary"
          @click="submitForm('ruleForm')"
          >{{ !disabled ? "立即创建" : "立即修改" }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "usermanage-dialog",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object,
      default: null
    }
  },
  data() {
    var validate = (rule, value, callback) => {
      if (value === "" && this.ruleForm.password !== "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      changePassBtn: false,
      disabled: false,
      loading: false,
      ruleForm: {
        value: "ADMIN",
        loginName: "",
        detail: "",
        email: "",
        password: "",
        password2: ""
      },
      validatePass: validate,
      rules: {
        loginName: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }
        ],
        detail: [
          {
            required: false,
            message: "请输入备注",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur"
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "blur,change"
          }
        ]
      }
    };
  },
  watch: {
    dialog: {
      immediate: true,
      handler(v) {
        if (v && this.dialogData) {
          this.ruleForm = {
            value: this.dialogData.role,
            loginName: this.dialogData.userName,
            detail: this.dialogData.detail,
            password: "",
            password2: ""
          };
        }
      }
    },
    dialogData: {
      immediate: true,
      handler(v) {
        if (v) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      }
    }
  },
  methods: {
    resetForm(form) {
      this.ruleForm = {
        value: "ADMIN",
        loginName: "",
        detail: "",
        email: "",
        password: "",
        password2: ""
      };
      this.$refs[form].resetFields();
      this.$emit("update:dialog", false);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogData) {
            this.setUser();
          } else {
            this.newUser();
          }
        } else {
          return false;
        }
      });
    },
    newUser() {
      this.loading = true;
      let url = "/gavial/v1/manage/sys/ad/user?loginName=";
      if (this.ruleForm.value === "ADMIN") {
        url = "/gavial/v1/manage/sys/admin?loginName=";
      }
      this.$http
        .post(
          `${url}${encodeURIComponent(
            this.ruleForm.loginName
          )}&password=${encodeURIComponent(
            this.ruleForm.password
          )}&userName=${encodeURIComponent(
            this.ruleForm.loginName
          )}&email=${encodeURIComponent(
            this.ruleForm.email
          )}&detail=${encodeURIComponent(this.ruleForm.detail)}`
        )
        .then(() => {
          this.$notify({
            type: "success",
            title: "成功",
            message: `${this.ruleForm.loginName} 创建成功`,
            duration: 2000
          });
          this.resetForm("ruleForm");
          this.$emit("refush");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setUser() {
      this.loading = true;
      this.$http
        .put(
          "/gavial/v1/manage/sys/role/" +
            this.dialogData.userId +
            "?role=" +
            this.ruleForm.value +
            "&password=" +
            encodeURIComponent(this.ruleForm.password)
        )
        .then(() => {
          this.$notify({
            type: "success",
            title: "成功",
            message: `${this.dialogData.userName} 身份修改成功！`,
            duration: 2000
          });
          this.resetForm("ruleForm");
          this.$emit("refush");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
